import type { FunctionComponent } from 'react'
import React from 'react'
import { ButtonLink, Link, TypographyV2 as Typography } from '@which/seatbelt'

import styles from './FreeArticleSignup.module.scss'

export const FreeArticleSignup: FunctionComponent<Props> = ({ loggedIn }) => {
  const registerRedirectUrl = new URL(location.href)
  registerRedirectUrl.searchParams.set('hasSignedUpForFreeAccount', 'true')

  return (
    <div className={styles.freeArticleSignup}>
      <div className={styles.freeArticleSignupContainer}>
        <div className={styles.freeArticleSignupGradientBackground} />
        <Typography tag="h3" textStyle="sb-text-heading-medium">
          Unlock this article for free to get the full verdict
        </Typography>
        <Typography
          tag="p"
          textStyle="sb-text-interface-body-default-regular"
          className={styles.freeArticleSignupText}
        >
          Join for free to unlock this article and get the advice you need to shop with confidence.
          Plus, we’ll send a handpicked review to your inbox every fortnight if you opt-in. No
          payment details required.
        </Typography>
        <>
          <ButtonLink
            className={styles.freeArticleSignupButton}
            appearance="primary"
            data-which-id="locked-fa-signup-button"
            data-item-spec="free account locked article"
            data-action-group="free account signup"
            data-card-name="Sign up for a free account"
            data-section="Unlock this article for free to get the full verdict"
            href={`${!loggedIn ? `/registration?freeAccount=true&freeArticle=true&redirect=${encodeURIComponent(registerRedirectUrl.toString())}` : `/free-account?return_url=${encodeURIComponent(location.pathname)}`}`}
          >
            Sign up for a free account
          </ButtonLink>
          {!loggedIn && (
            <Typography
              textStyle="sb-text-interface-body-default-regular"
              className={styles.freeArticleSignupLogin}
            >
              Already have an account?{' '}
              <Link
                href="/login"
                textStyle="sb-text-interface-body-default-regular"
                data-which-id="locked-fa-login-link"
                data-card-name="login"
                data-section="Unlock this article for free to get the full verdict"
                data-action-group="login"
                data-item-spec="free account locked article"
              >
                Log in
              </Link>
            </Typography>
          )}
        </>
      </div>
      <Typography
        textStyle="sb-text-body-x-small-regular"
        className={styles.freeArticleSignupTerms}
      >
        Unsubscribe anytime. See our full{' '}
        <Link
          href="/about-which/your-free-account-membership-a4j010q41ccC"
          textStyle="sb-text-interface-body-x-small-regular"
        >
          terms & conditions
        </Link>
      </Typography>
    </div>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  loggedIn?: boolean
}
